/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import DateBoundary from './DateBoundary';
import NumberBoundary from './NumberBoundary';

/**
 * The AqaVectorQualityDefinition model module.
 * @module model/AqaVectorQualityDefinition
 * @version v0
 */
export default class AqaVectorQualityDefinition {
  /**
   * Constructs a new <code>AqaVectorQualityDefinition</code>.
   * @alias module:model/AqaVectorQualityDefinition
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaVectorQualityDefinition</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaVectorQualityDefinition} obj Optional instance to populate.
   * @return {module:model/AqaVectorQualityDefinition} The populated <code>AqaVectorQualityDefinition</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaVectorQualityDefinition();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('lastModifiedTimestamp'))
        obj.lastModifiedTimestamp = ApiClient.convertToType(data['lastModifiedTimestamp'], 'Number');
      if (data.hasOwnProperty('qualityEnabled'))
        obj.qualityEnabled = ApiClient.convertToType(data['qualityEnabled'], 'Boolean');
      if (data.hasOwnProperty('typeEnabled'))
        obj.typeEnabled = ApiClient.convertToType(data['typeEnabled'], 'Boolean');
      if (data.hasOwnProperty('requiredType'))
        obj.requiredType = ApiClient.convertToType(data['requiredType'], 'String');
      if (data.hasOwnProperty('typeSeverity'))
        obj.typeSeverity = ApiClient.convertToType(data['typeSeverity'], 'String');
      if (data.hasOwnProperty('uniquenessEnabled'))
        obj.uniquenessEnabled = ApiClient.convertToType(data['uniquenessEnabled'], 'Boolean');
      if (data.hasOwnProperty('uniquenessType'))
        obj.uniquenessType = ApiClient.convertToType(data['uniquenessType'], 'String');
      if (data.hasOwnProperty('uniquenessBoundary'))
        obj.uniquenessBoundary = NumberBoundary.constructFromObject(data['uniquenessBoundary']);
      if (data.hasOwnProperty('ignoreBlankValues'))
        obj.ignoreBlankValues = ApiClient.convertToType(data['ignoreBlankValues'], 'Boolean');
      if (data.hasOwnProperty('populatedEnabled'))
        obj.populatedEnabled = ApiClient.convertToType(data['populatedEnabled'], 'Boolean');
      if (data.hasOwnProperty('populatedType'))
        obj.populatedType = ApiClient.convertToType(data['populatedType'], 'String');
      if (data.hasOwnProperty('populatedBoundary'))
        obj.populatedBoundary = NumberBoundary.constructFromObject(data['populatedBoundary']);
      if (data.hasOwnProperty('useNumberBoundaries'))
        obj.useNumberBoundaries = ApiClient.convertToType(data['useNumberBoundaries'], 'Boolean');
      if (data.hasOwnProperty('useNumberFormats'))
        obj.useNumberFormats = ApiClient.convertToType(data['useNumberFormats'], 'Boolean');
      if (data.hasOwnProperty('numberBoundary1'))
        obj.numberBoundary1 = NumberBoundary.constructFromObject(data['numberBoundary1']);
      if (data.hasOwnProperty('numberBoundary2'))
        obj.numberBoundary2 = NumberBoundary.constructFromObject(data['numberBoundary2']);
      if (data.hasOwnProperty('greenNumberFormats'))
        obj.greenNumberFormats = ApiClient.convertToType(data['greenNumberFormats'], ['String']);
      if (data.hasOwnProperty('amberNumberFormats'))
        obj.amberNumberFormats = ApiClient.convertToType(data['amberNumberFormats'], ['String']);
      if (data.hasOwnProperty('redNumberFormats'))
        obj.redNumberFormats = ApiClient.convertToType(data['redNumberFormats'], ['String']);
      if (data.hasOwnProperty('unlistedNumberFormatColour'))
        obj.unlistedNumberFormatColour = ApiClient.convertToType(data['unlistedNumberFormatColour'], 'String');
      if (data.hasOwnProperty('useDateBoundaries'))
        obj.useDateBoundaries = ApiClient.convertToType(data['useDateBoundaries'], 'Boolean');
      if (data.hasOwnProperty('useDateFormats'))
        obj.useDateFormats = ApiClient.convertToType(data['useDateFormats'], 'Boolean');
      if (data.hasOwnProperty('dateBoundary1'))
        obj.dateBoundary1 = DateBoundary.constructFromObject(data['dateBoundary1']);
      if (data.hasOwnProperty('dateBoundary2'))
        obj.dateBoundary2 = DateBoundary.constructFromObject(data['dateBoundary2']);
      if (data.hasOwnProperty('greenDateFormats'))
        obj.greenDateFormats = ApiClient.convertToType(data['greenDateFormats'], ['String']);
      if (data.hasOwnProperty('amberDateFormats'))
        obj.amberDateFormats = ApiClient.convertToType(data['amberDateFormats'], ['String']);
      if (data.hasOwnProperty('redDateFormats'))
        obj.redDateFormats = ApiClient.convertToType(data['redDateFormats'], ['String']);
      if (data.hasOwnProperty('unlistedDateFormatColour'))
        obj.unlistedDateFormatColour = ApiClient.convertToType(data['unlistedDateFormatColour'], 'String');
      if (data.hasOwnProperty('useStringLengths'))
        obj.useStringLengths = ApiClient.convertToType(data['useStringLengths'], 'Boolean');
      if (data.hasOwnProperty('useAllowedValues'))
        obj.useAllowedValues = ApiClient.convertToType(data['useAllowedValues'], 'Boolean');
      if (data.hasOwnProperty('useStringFormats'))
        obj.useStringFormats = ApiClient.convertToType(data['useStringFormats'], 'Boolean');
      if (data.hasOwnProperty('stringLengthBoundary1'))
        obj.stringLengthBoundary1 = NumberBoundary.constructFromObject(data['stringLengthBoundary1']);
      if (data.hasOwnProperty('stringLengthBoundary2'))
        obj.stringLengthBoundary2 = NumberBoundary.constructFromObject(data['stringLengthBoundary2']);
      if (data.hasOwnProperty('greenStringValues'))
        obj.greenStringValues = ApiClient.convertToType(data['greenStringValues'], ['String']);
      if (data.hasOwnProperty('amberStringValues'))
        obj.amberStringValues = ApiClient.convertToType(data['amberStringValues'], ['String']);
      if (data.hasOwnProperty('redStringValues'))
        obj.redStringValues = ApiClient.convertToType(data['redStringValues'], ['String']);
      if (data.hasOwnProperty('unlistedStringValueColour'))
        obj.unlistedStringValueColour = ApiClient.convertToType(data['unlistedStringValueColour'], 'String');
      if (data.hasOwnProperty('greenStringFormats'))
        obj.greenStringFormats = ApiClient.convertToType(data['greenStringFormats'], ['String']);
      if (data.hasOwnProperty('amberStringFormats'))
        obj.amberStringFormats = ApiClient.convertToType(data['amberStringFormats'], ['String']);
      if (data.hasOwnProperty('redStringFormats'))
        obj.redStringFormats = ApiClient.convertToType(data['redStringFormats'], ['String']);
      if (data.hasOwnProperty('unlistedStringFormatColour'))
        obj.unlistedStringFormatColour = ApiClient.convertToType(data['unlistedStringFormatColour'], 'String');
      if (data.hasOwnProperty('nativeErrorsEnabled'))
        obj.nativeErrorsEnabled = ApiClient.convertToType(data['nativeErrorsEnabled'], 'Boolean');
      if (data.hasOwnProperty('numberRAG'))
        obj.numberRAG = ApiClient.convertToType(data['numberRAG'], 'String');
      if (data.hasOwnProperty('dateRAG'))
        obj.dateRAG = ApiClient.convertToType(data['dateRAG'], 'String');
      if (data.hasOwnProperty('stringRAG'))
        obj.stringRAG = ApiClient.convertToType(data['stringRAG'], 'String');
      if (data.hasOwnProperty('nativeErrorRAG'))
        obj.nativeErrorRAG = ApiClient.convertToType(data['nativeErrorRAG'], 'String');
      if (data.hasOwnProperty('machineSuggested'))
        obj.machineSuggested = ApiClient.convertToType(data['machineSuggested'], 'Boolean');
      if (data.hasOwnProperty('header'))
        obj.header = ApiClient.convertToType(data['header'], 'String');
      if (data.hasOwnProperty('journal'))
        obj.journal = ApiClient.convertToType(data['journal'], ['String']);
      if (data.hasOwnProperty('dateEnabled'))
        obj.dateEnabled = ApiClient.convertToType(data['dateEnabled'], 'Boolean');
      if (data.hasOwnProperty('shortId'))
        obj.shortId = ApiClient.convertToType(data['shortId'], 'String');
      if (data.hasOwnProperty('numberEnabled'))
        obj.numberEnabled = ApiClient.convertToType(data['numberEnabled'], 'Boolean');
      if (data.hasOwnProperty('stringEnabled'))
        obj.stringEnabled = ApiClient.convertToType(data['stringEnabled'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
AqaVectorQualityDefinition.prototype.id = undefined;

/**
 * @member {Number} lastModifiedTimestamp
 */
AqaVectorQualityDefinition.prototype.lastModifiedTimestamp = undefined;

/**
 * @member {Boolean} qualityEnabled
 */
AqaVectorQualityDefinition.prototype.qualityEnabled = undefined;

/**
 * @member {Boolean} typeEnabled
 */
AqaVectorQualityDefinition.prototype.typeEnabled = undefined;

/**
 * Allowed values for the <code>requiredType</code> property.
 * @enum {String}
 * @readonly
 */
AqaVectorQualityDefinition.RequiredTypeEnum = {
  /**
   * value: "unknown"
   * @const
   */
  unknown: "unknown",

  /**
   * value: "string"
   * @const
   */
  _string: "string",

  /**
   * value: "number"
   * @const
   */
  _number: "number",

  /**
   * value: "date"
   * @const
   */
  _date: "date",

  /**
   * value: "nativeError"
   * @const
   */
  nativeError: "nativeError"
};
/**
 * @member {module:model/AqaVectorQualityDefinition.RequiredTypeEnum} requiredType
 */
AqaVectorQualityDefinition.prototype.requiredType = undefined;

/**
 * Allowed values for the <code>typeSeverity</code> property.
 * @enum {String}
 * @readonly
 */
AqaVectorQualityDefinition.TypeSeverityEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaVectorQualityDefinition.TypeSeverityEnum} typeSeverity
 */
AqaVectorQualityDefinition.prototype.typeSeverity = undefined;

/**
 * @member {Boolean} uniquenessEnabled
 */
AqaVectorQualityDefinition.prototype.uniquenessEnabled = undefined;

/**
 * Allowed values for the <code>uniquenessType</code> property.
 * @enum {String}
 * @readonly
 */
AqaVectorQualityDefinition.UniquenessTypeEnum = {
  /**
   * value: "UniquePercentage"
   * @const
   */
  uniquePercentage: "UniquePercentage",

  /**
   * value: "DuplicatesAllowed"
   * @const
   */
  duplicatesAllowed: "DuplicatesAllowed",

  /**
   * value: "RepeatsAllowed"
   * @const
   */
  repeatsAllowed: "RepeatsAllowed"
};
/**
 * @member {module:model/AqaVectorQualityDefinition.UniquenessTypeEnum} uniquenessType
 */
AqaVectorQualityDefinition.prototype.uniquenessType = undefined;

/**
 * @member {module:model/NumberBoundary} uniquenessBoundary
 */
AqaVectorQualityDefinition.prototype.uniquenessBoundary = undefined;

/**
 * @member {Boolean} ignoreBlankValues
 */
AqaVectorQualityDefinition.prototype.ignoreBlankValues = undefined;

/**
 * @member {Boolean} populatedEnabled
 */
AqaVectorQualityDefinition.prototype.populatedEnabled = undefined;

/**
 * Allowed values for the <code>populatedType</code> property.
 * @enum {String}
 * @readonly
 */
AqaVectorQualityDefinition.PopulatedTypeEnum = {
  /**
   * value: "percentagePopulated"
   * @const
   */
  percentagePopulated: "percentagePopulated",

  /**
   * value: "absolutePopulated"
   * @const
   */
  absolutePopulated: "absolutePopulated"
};
/**
 * @member {module:model/AqaVectorQualityDefinition.PopulatedTypeEnum} populatedType
 */
AqaVectorQualityDefinition.prototype.populatedType = undefined;

/**
 * @member {module:model/NumberBoundary} populatedBoundary
 */
AqaVectorQualityDefinition.prototype.populatedBoundary = undefined;

/**
 * @member {Boolean} useNumberBoundaries
 */
AqaVectorQualityDefinition.prototype.useNumberBoundaries = undefined;

/**
 * @member {Boolean} useNumberFormats
 */
AqaVectorQualityDefinition.prototype.useNumberFormats = undefined;

/**
 * @member {module:model/NumberBoundary} numberBoundary1
 */
AqaVectorQualityDefinition.prototype.numberBoundary1 = undefined;

/**
 * @member {module:model/NumberBoundary} numberBoundary2
 */
AqaVectorQualityDefinition.prototype.numberBoundary2 = undefined;

/**
 * @member {Array.<String>} greenNumberFormats
 */
AqaVectorQualityDefinition.prototype.greenNumberFormats = undefined;

/**
 * @member {Array.<String>} amberNumberFormats
 */
AqaVectorQualityDefinition.prototype.amberNumberFormats = undefined;

/**
 * @member {Array.<String>} redNumberFormats
 */
AqaVectorQualityDefinition.prototype.redNumberFormats = undefined;

/**
 * Allowed values for the <code>unlistedNumberFormatColour</code> property.
 * @enum {String}
 * @readonly
 */
AqaVectorQualityDefinition.UnlistedNumberFormatColourEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaVectorQualityDefinition.UnlistedNumberFormatColourEnum} unlistedNumberFormatColour
 */
AqaVectorQualityDefinition.prototype.unlistedNumberFormatColour = undefined;

/**
 * @member {Boolean} useDateBoundaries
 */
AqaVectorQualityDefinition.prototype.useDateBoundaries = undefined;

/**
 * @member {Boolean} useDateFormats
 */
AqaVectorQualityDefinition.prototype.useDateFormats = undefined;

/**
 * @member {module:model/DateBoundary} dateBoundary1
 */
AqaVectorQualityDefinition.prototype.dateBoundary1 = undefined;

/**
 * @member {module:model/DateBoundary} dateBoundary2
 */
AqaVectorQualityDefinition.prototype.dateBoundary2 = undefined;

/**
 * @member {Array.<String>} greenDateFormats
 */
AqaVectorQualityDefinition.prototype.greenDateFormats = undefined;

/**
 * @member {Array.<String>} amberDateFormats
 */
AqaVectorQualityDefinition.prototype.amberDateFormats = undefined;

/**
 * @member {Array.<String>} redDateFormats
 */
AqaVectorQualityDefinition.prototype.redDateFormats = undefined;

/**
 * Allowed values for the <code>unlistedDateFormatColour</code> property.
 * @enum {String}
 * @readonly
 */
AqaVectorQualityDefinition.UnlistedDateFormatColourEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaVectorQualityDefinition.UnlistedDateFormatColourEnum} unlistedDateFormatColour
 */
AqaVectorQualityDefinition.prototype.unlistedDateFormatColour = undefined;

/**
 * @member {Boolean} useStringLengths
 */
AqaVectorQualityDefinition.prototype.useStringLengths = undefined;

/**
 * @member {Boolean} useAllowedValues
 */
AqaVectorQualityDefinition.prototype.useAllowedValues = undefined;

/**
 * @member {Boolean} useStringFormats
 */
AqaVectorQualityDefinition.prototype.useStringFormats = undefined;

/**
 * @member {module:model/NumberBoundary} stringLengthBoundary1
 */
AqaVectorQualityDefinition.prototype.stringLengthBoundary1 = undefined;

/**
 * @member {module:model/NumberBoundary} stringLengthBoundary2
 */
AqaVectorQualityDefinition.prototype.stringLengthBoundary2 = undefined;

/**
 * @member {Array.<String>} greenStringValues
 */
AqaVectorQualityDefinition.prototype.greenStringValues = undefined;

/**
 * @member {Array.<String>} amberStringValues
 */
AqaVectorQualityDefinition.prototype.amberStringValues = undefined;

/**
 * @member {Array.<String>} redStringValues
 */
AqaVectorQualityDefinition.prototype.redStringValues = undefined;

/**
 * Allowed values for the <code>unlistedStringValueColour</code> property.
 * @enum {String}
 * @readonly
 */
AqaVectorQualityDefinition.UnlistedStringValueColourEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaVectorQualityDefinition.UnlistedStringValueColourEnum} unlistedStringValueColour
 */
AqaVectorQualityDefinition.prototype.unlistedStringValueColour = undefined;

/**
 * @member {Array.<String>} greenStringFormats
 */
AqaVectorQualityDefinition.prototype.greenStringFormats = undefined;

/**
 * @member {Array.<String>} amberStringFormats
 */
AqaVectorQualityDefinition.prototype.amberStringFormats = undefined;

/**
 * @member {Array.<String>} redStringFormats
 */
AqaVectorQualityDefinition.prototype.redStringFormats = undefined;

/**
 * Allowed values for the <code>unlistedStringFormatColour</code> property.
 * @enum {String}
 * @readonly
 */
AqaVectorQualityDefinition.UnlistedStringFormatColourEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaVectorQualityDefinition.UnlistedStringFormatColourEnum} unlistedStringFormatColour
 */
AqaVectorQualityDefinition.prototype.unlistedStringFormatColour = undefined;

/**
 * @member {Boolean} nativeErrorsEnabled
 */
AqaVectorQualityDefinition.prototype.nativeErrorsEnabled = undefined;

/**
 * Allowed values for the <code>numberRAG</code> property.
 * @enum {String}
 * @readonly
 */
AqaVectorQualityDefinition.NumberRAGEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaVectorQualityDefinition.NumberRAGEnum} numberRAG
 */
AqaVectorQualityDefinition.prototype.numberRAG = undefined;

/**
 * Allowed values for the <code>dateRAG</code> property.
 * @enum {String}
 * @readonly
 */
AqaVectorQualityDefinition.DateRAGEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaVectorQualityDefinition.DateRAGEnum} dateRAG
 */
AqaVectorQualityDefinition.prototype.dateRAG = undefined;

/**
 * Allowed values for the <code>stringRAG</code> property.
 * @enum {String}
 * @readonly
 */
AqaVectorQualityDefinition.StringRAGEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaVectorQualityDefinition.StringRAGEnum} stringRAG
 */
AqaVectorQualityDefinition.prototype.stringRAG = undefined;

/**
 * Allowed values for the <code>nativeErrorRAG</code> property.
 * @enum {String}
 * @readonly
 */
AqaVectorQualityDefinition.NativeErrorRAGEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaVectorQualityDefinition.NativeErrorRAGEnum} nativeErrorRAG
 */
AqaVectorQualityDefinition.prototype.nativeErrorRAG = undefined;

/**
 * @member {Boolean} machineSuggested
 */
AqaVectorQualityDefinition.prototype.machineSuggested = undefined;

/**
 * @member {String} header
 */
AqaVectorQualityDefinition.prototype.header = undefined;

/**
 * @member {Array.<String>} journal
 */
AqaVectorQualityDefinition.prototype.journal = undefined;

/**
 * @member {Boolean} dateEnabled
 */
AqaVectorQualityDefinition.prototype.dateEnabled = undefined;

/**
 * @member {String} shortId
 */
AqaVectorQualityDefinition.prototype.shortId = undefined;

/**
 * @member {Boolean} numberEnabled
 */
AqaVectorQualityDefinition.prototype.numberEnabled = undefined;

/**
 * @member {Boolean} stringEnabled
 */
AqaVectorQualityDefinition.prototype.stringEnabled = undefined;

